
import { Navigate } from "react-router-dom";
import { checkAccess } from "@/utils/passwords";

const PasswordProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const hasAccess = checkAccess();

  if (!hasAccess) {
    return <Navigate to="/verify-access" replace />;
  }

  return <>{children}</>;
};

export default PasswordProtectedRoute;
